export default "__VITE_ASSET__MXDznaZP__"